import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import BaseComponent from 'common/BaseComponent';
import {ValidationResult} from 'validation'
import Table from 'common/Table';
import update from 'immutability-helper';
import checkOkIcon from './check_ok.png';
import checkFailIcon from './check_fail.png';
import deleteIcon from './delete.png';
import reloadIcon from './reload.png';
import theme from './ImeiTab.scss';
import conf from 'configuration.json';
import Input from 'common/Input';
import {getMessage as msg} from 'MessageBundle'

export default class ImeiTab extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {};

        this.tableStructure = [
            {
                attribute: "status", label: msg("imeiTab.columnCheck"), headStyle: theme.columnCheck, bodyStyle: theme.txtCenter,
                render: (row) => {
                    const hint = row.retryRequired ? msg("imeiTab.itemNotValid") : msg("imeiTab.itemValid");
                    return <img src={row.retryRequired ? checkFailIcon : checkOkIcon} title={hint} alt={hint}/>;
                }
            },
            {
                attribute: "imeiNumber", label: msg("imeiTab.columnIMEI"), headStyle: theme.columnIMEI, bodyStyle: classnames(theme.columnIMEI, theme.txtRight),
                render: (row, index) => {
                    if (row.editable) {
                        return <Input id="imeiNumber-input" disabled={this.props.readOnly} value={row.imeiNumber || ""} onChange={this.handleImeiChange("imeiNumber", index)}
                            allowedSymbols={"^[0-9]$"} maxLength={15}/>;
                    }
                    else {
                        return <div>{row.imeiNumber || ""}</div>;
                    }
                }
            },
            {
                attribute: "invoiceNumber", label: msg("imeiTab.columnInvoiceNumber"), headStyle: theme.columnInvoiceNumber,
                bodyStyle: classnames(theme.columnInvoiceNumber, theme.txtRight),
                render: (row, index) => {
                    if (row.editable) {
                        return <Input id="invoiceNumber-input" value={row.invoiceNumber || ""} disabled={this.props.readOnly} onChange={this.handleImeiChange("invoiceNumber", index)}
                            allowedSymbols={"^[0-9]$"} maxLength={10}/>;
                    }
                    else {
                        return <div>{row.invoiceNumber || ""}</div>;
                    }
                }
            },
            {
                attribute: "deliveryNoteNumber", label: msg("imeiTab.columnDeliveryNoteNumber"), fullLabel: msg("imeiTab.columnDeliveryNoteNumber.full"),
                headStyle: theme.columnDeliveryNoteNumber, bodyStyle: classnames(theme.columnDeliveryNoteNumber, theme.txtRight),
                render: (row, index) => {
                    if (row.editable) {
                        return <Input id="deliveryNoteNumber-input" value={row.deliveryNoteNumber || ""} disabled={this.props.readOnly} onChange={this.handleImeiChange("deliveryNoteNumber", index)}
                            allowedSymbols={"^[0-9]$"} maxLength={10}/>;
                    }
                    else {
                        return <div>{row.deliveryNoteNumber || ""}</div>;
                    }
                }
            },
            {
                attribute: "activationDate", label: msg("imeiTab.columnActivationDate"), headStyle: theme.columnActivationDate, bodyStyle: theme.txtRight,
                render: (row, index) => {
                    return <div>{row.activationDate || msg("imeiTab.notActivation")}</div>;
                }
            },
            {
                attribute: "uvoActivation", label: msg("imeiTab.columnUvoActivation"), headStyle: theme.columnUvoActivation, bodyStyle: theme.columnUvoActivation,
                render: (row, index) => {
                    return <div>{row.uvoActivation || msg("imeiTab.notActivation")}</div>
                }
            },
            {
                attribute: "action", label: msg("imeiTab.columnAction"), headStyle: theme.columnAction, bodyStyle: theme.txtCenter,
                render: (row, index) => {
                    return (
                        <a href="javascript:void(0)" onClick={this.props.readOnly ? () => {} : () => this.remove(index)} title={msg("imeiTab.deleteButton")}>
                            <img src={deleteIcon} alt=""/>
                        </a>
                    );
                }
            }
        ];

        this.lastRowStructure = [
            {
                attribute: "status", label: msg("imeiTab.columnCheck"), headStyle: theme.columnCheck, bodyStyle: theme.txtCenter,
                render: () => {
                    return (
                        <button className={theme.buttonGray}
                            onClick={() => {this.setState({newImeiShown: true, newImei: {}}, () => this.imeiNumber.focus())}}>
                            {msg("imeiTab.newButton")}
                        </button>
                    );
                }
            },
            {
                attribute: "imeiNumber", label: msg("imeiTab.columnIMEI"), headStyle: theme.columnIMEI, bodyStyle: classnames(theme.columnIMEI, theme.txtRight),
                render: () => {
                    return(
                        this.state.newImeiShown ? <Input id="addedImeinumber-input"
                                value={this.state.newImei.imeiNumber ? this.state.newImei.imeiNumber : ""}
                                onChange={this.handleNestedChange("newImei", "imeiNumber")} allowedSymbols={"^[0-9]$"}
                                maxLength={15} ref={(imeiNumber) => this.imeiNumber = imeiNumber}/>
                            : null
                    );
                }
            },
            {
                attribute: "invoiceNumber", label: msg("imeiTab.columnInvoiceNumber"), headStyle: theme.columnInvoiceNumber, bodyStyle: classnames(theme.columnInvoiceNumber, theme.txtRight, theme.columnDisable),
                render: () => {
                    return null;
                }
            },
            {
                attribute: "deliveryNoteNumber", label: msg("imeiTab.columnDeliveryNoteNumber"), headStyle: theme.columnDeliveryNoteNumber, bodyStyle: classnames(theme.columnDeliveryNoteNumber, theme.txtRight, theme.columnDisable),
                render: () => {
                    return null;
                }
            },
            {
                attribute: "activationDate", label: msg("imeiTab.columnActivationDate"), headStyle: theme.columnActivationDate, bodyStyle: classnames(theme.txtRight, theme.columnDisable),
                render: () => {
                    return null;
                }
            },
            {
                attribute: "uvoActivation", label: msg("imeiTab.columnUvoActivation"), headStyle: theme.columnUvoActivation, bodyStyle: classnames(theme.columnUvoActivation, theme.columnDisable),
                render: () => {
                    return null;
                }
            },
            {
                attribute: "action", label: msg("imeiTab.columnAction"), headStyle: theme.columnAction, bodyStyle: theme.txtCenter,
                render: () => {
                    return (
                        <a href="javascript:void(0)" onClick={this.reload} title={msg("imeiTab.refreshButton")}>
                            <img src={reloadIcon} alt=""/>
                        </a>
                    );
                }
            }
        ];
    }

    resetState = () => {
        this.setState({
            newImei: {},
            newImeiShown: false
        });
    };

    reload = () => {
        if(this.state.newImei.imeiNumber){
            const validationResult = new ValidationResult(this.props.errorMessages);
            validationResult.resetGroups(["imeiTab"]);
            this.request('get', conf.rest.imeiEndpoint + '/' + this.state.newImei.imeiNumber).send((imeiResult) => {
                this.resetState();
                this.props.onImeiReload(imeiResult.body.invoiceNumber);
                const updatedImeis = update(this.props.value.imeis, {$push: [imeiResult.body]});

                this.props.onChange({'imeis': updatedImeis});

                if(imeiResult.body.invoiceNumber === undefined) {
                    validationResult.setError("imeiTab", msg("imeiTab.itemNotFound"));
                }
                this.props.onError(validationResult.getErrorMessages());
            }, () => {
                this.resetState();
                validationResult.setError("imeiTab", msg("imeiTab.sapError"));
                this.props.onError(validationResult.getErrorMessages());
            })
        }
    };

    handleImeiChange = (name, index) => (event) => {
        let updated = update(this.props.value.imeis, {[index]: {[name]: {$set: event.target.value}}});
        this.props.onChange({'imeis': updated});
    };

    remove = (rowId) => {
        if(confirm(msg("imeiTab.deleteConfirm"))) {
            const updated = update(this.props.value.imeis, {$splice: [[rowId, 1]]});
            this.props.onChange({'imeis': updated});
        }
    };

    render() {
        return (
            <div className={theme.imeiTab}>
                <div className={theme.tblWrap}>
                    <div className={theme.tblWrapInner}>
                        <Table structure={this.tableStructure} lastRowStructure={this.props.readOnly ? undefined : this.lastRowStructure} value={this.props.value.imeis} className={theme.imeiTabTbl}/>
                    </div>
                </div>
            </div>
        );
    }
}

ImeiTab.propTypes = {
    /**
     * The imeiTab part of complaint with all data needed for imei Tab.
     */
    value: PropTypes.object.isRequired,

    /**
     * Function, called on imei tab data change
     */
    onChange: PropTypes.func,

    /**
     * Function, called on imei reload
     */
    onImeiReload: PropTypes.func,

    /**
     * Array of error messages to be shown on the tab.
     */
    errorMessage: PropTypes.array,

    /**
     * Function, called in case error is happened
     */
    onError: PropTypes.func,


    /**
     *  Flag, showing complaint is editable or not.
     */
    readOnly: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/ImeiTab/index.js